// Reported alongside browser-side failures so telemetry can be broken down by the
// deployed client. Keep in step with the version in package.json.
//
// Deliberately standalone: telemetry must not drag in `consts`, which touches
// `window.matchMedia` at import time.
export const CLIENT_VERSION = '1.0.0'
